import { SceneData } from 'src/utils/types/scene';

import { IconAssets } from '../../utils/enums/assets';
import { Scenes } from '../../utils/enums/scenes';
import { WithScoreScene } from '../classes/WithScoreScene';
import { UI } from '../ui/ui';

export class GameOver extends WithScoreScene {
  private score = 0;

  constructor() {
    super(Scenes.GAME_OVER);
  }

  preload(): void {
    this.load.image(IconAssets.AVATAR_ICON, './assets/icons/avatar-sample.png');
  }

  init(data: SceneData & { score: number }): void {
    this.score = data.score || 0;
    this.user = data.user;
  }

  create(): void {
    this.renderBackground();
    this.renderGameOverText();
    this.renderTopPlayers();
    this.renderButtons();
    this.scene.stop(Scenes.LOADING);
  }

  update(): void {
    this.updateTopPlayersUi();
  }

  private renderBackground(): void {
    UI.images.Background(this);
  }

  private renderGameOverText(): void {
    UI.text.GameOver(this);
    UI.text.GameOverScore(this, this.score);
    UI.text.HighScores(this);
  }

  private renderTopPlayers(): void {
    this.topPlayersUi = UI.components.TopPlayers(this);
  }

  private renderButtons(): void {
    UI.buttons.GameOverRestart(this, () => {
      this.scene.stop();
      this.resetApiFlags();
      this.scene.start(Scenes.GAME, { user: this.user });

      this.handleSoundOnRestart();
    });

    UI.icons.HomeIcon(this, { interactive: true }).on('pointerdown', () => {
      this.scene.stop();
      this.resetApiFlags();
      this.scene.start(Scenes.EXIT_GAME, { user: this.user });
    });

    UI.icons.FullScreenIcon(this);
  }

  private handleSoundOnRestart(): void {
    if (!this.registry.get('isMuted')) {
      this.sound.resumeAll();
    } else {
      this.sound.stopAll();
    }
  }
}
